import { Injectable } from "@angular/core";
import { MessageService } from 'primeng/api';
import { ApiErrorCode } from "shared/service-proxies/service-proxies";

@Injectable({ providedIn: 'root' })
export class ToasterService {

  constructor(private messageService: MessageService) { }

  showApiValidation(response: ApiValidationResponse) {
    if (response.errorCode == ApiErrorCode._1) {
      this.toastWarning(response.errorTitle ? response.errorTitle : "Warning", response.errorMessage);
    } else {
      this.toastError(response.errorTitle ? response.errorTitle : "Error", response.errorMessage);
    }
  }

  toastSuccess(message: string, detail: string = '') {
    this.messageService.add({ severity: 'success', summary: message, detail: detail, life: 5000 });
  }

  toastError(message: string, detail: string = '') {
    this.messageService.add({ severity: 'error', summary: message, detail: detail, life: 5000 });
  }

  toastInfo(message: string, detail: string = '') {
    this.messageService.add({ severity: 'info', summary: message, detail: detail, life: 5000 });
  }

  toastWarning(message: string, detail: string = '') {
    this.messageService.add({ severity: 'warn', summary: message, detail: detail, life: 5000 });
  }
}

export class ApiValidationResponse {
  errorCode: ApiErrorCode;
  errorMessage: string | undefined;
  errorTitle: string | undefined;
}
